module.exports = __webpack_public_path__ + "img/right2.f483c055.png";